var path = '/templates/projects/views/directives/project_search_single.html';
var html = "<a><span bind-html-unsafe=\"match.label | typeaheadHighlight:query\"></span></a>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ../enterprise/src/zenclerk_modules/projects/views/directives/project_search_single.html
// module id = 1609
// module chunks = 0